import { render, staticRenderFns } from "./ProductosProcessAdmin.vue?vue&type=template&id=7bf9875d&scoped=true&"
import script from "./ProductosProcessAdmin.vue?vue&type=script&lang=js&"
export * from "./ProductosProcessAdmin.vue?vue&type=script&lang=js&"
import style0 from "./ProductosProcessAdmin.vue?vue&type=style&index=0&id=7bf9875d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf9875d",
  null
  
)

export default component.exports